const styles = (theme) => ({
  label: {
    display: 'flex',
    alignItems: 'center',
    height: 50,
    color: theme.color.black_80,
    cursor: 'pointer',
  },
  iconContainer: {
    height: 50,
    width: 25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 15,
  },
  icon: {
    height: 25,
    width: 25,
  },
  checkbox: {
    marginLeft: 'auto',
  },
  checkedIcon: {
    fill: theme.color.green,
  },
});

export default styles;
